import ListCustomers from "../../../../components/@users/customers/ListCustomers";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function CustomersPage() {

    return (
        <ListCustomers 
            routeType={routeTypes.admin}
        />
    )
}       